
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewsContainer } from './reviews.container';
import { ReviewsComponent } from './reviews.component';
import { CarouselModule } from 'outshared-lib';

@NgModule({
    imports: [
        CommonModule,
        CarouselModule,
    ],
    exports: [
        ReviewsContainer,
        ReviewsComponent
    ],
    declarations: [
        ReviewsContainer,
        ReviewsComponent
    ],
    providers: []
})
export class ReviewsModule {
}
